import { Grid, TextField } from '@mui/material';
import React, { useContext, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { useSearchParams } from 'react-router-dom';
import styles from "../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import agent from '../../../services/api';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

const OrganizationHeaderText = () => {
    
    const { setFlagLoading, handleError, userDetail, organizationDetails, setOrganizationDetails } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))
    
    const [searchParams, setSearchParams] = useSearchParams()
    const organization_id = searchParams.get('organization_id')

    const getOrganizationName = () => {
        return organizationDetails?.find((organization) => organization.organization_id === Number(organization_id))?.organization_name ?? "";
    }
    
    const [flagEditOrganizationName, setFlagEditOrganizationName] = useState<boolean>(false);
    const [workspaceName, setWorkspaceName] = useState<string>(getOrganizationName());
    
    const hasAccessToRenameWorkspace = organizationDetails?.find((organization) => organization.organization_id === Number(organization_id))?.organization_user_data?.find((user) => user.private_user_id == userDetail?.user_id)?.user_organization_role_name?.toLowerCase() == "organization owner";

    const onChangeOfOrganizationName = (value: string) => {
        setWorkspaceName(value);
    }

    const renameOrganizationNameApi = async (organization_name: string) => {
        if(organization_name != getOrganizationName()){
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            const payload = {
                organization_name: organization_name,
            }
            const res = await agent.updateOrganizationName.put(payload);
            if(!(res.status)){
                handleError(res);
            } else {
                showSuccess("Workspace name updated successfully.")
                setOrganizationDetails((prev) => {
                    if(!prev) return prev;
    
                    const updatedData = prev?.map((organization) => {
                        if(organization?.organization_id == Number(organization_id)){
                            return {
                                ...organization, 
                                organization_name: organization_name,
                            }
                        }
                        return organization;
                    }); 
    
                    return updatedData;
                });
            }
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    const onBlurOfTextField = (value: string) => {
        renameOrganizationNameApi(value);
        setFlagEditOrganizationName(false);
    }

    return (
        <>
            <Grid item>
                <Grid container gap={1} alignItems={"center"}>
                    {!flagEditOrganizationName && 
                        <Grid item>
                            {workspaceName}
                        </Grid>
                    }

                    {hasAccessToRenameWorkspace && 
                        <Grid item>
                            {flagEditOrganizationName ?  
                                <TextField
                                    placeholder='Enter Workspace Name' 
                                    className={`${styles.editableWorkspaceName}`}
                                    value={workspaceName}
                                    onChange={(e) => onChangeOfOrganizationName(e.target.value)}
                                    onBlur={(e) => { 
                                        if(e.target.value?.trim()?.length > 0){
                                            onBlurOfTextField(e.target.value);
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        const value = (e.target as HTMLInputElement).value;
                                        if (e.key?.toLowerCase() == "enter" && value?.trim()?.length > 0) {
                                            onBlurOfTextField(value);
                                        }
                                    }}
                                    autoFocus
                                />
                                : 
                                <EditIcon
                                    className={styles.editWorkspaceNameIcon}
                                    onClick={() => setFlagEditOrganizationName(true)}
                                />
                            }
                        </Grid>
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default OrganizationHeaderText
